import { render, staticRenderFns } from "./dialog-save-button.vue?vue&type=template&id=3c900c3a&scoped=true"
import script from "./dialog-save-button.vue?vue&type=script&lang=js"
export * from "./dialog-save-button.vue?vue&type=script&lang=js"
import style0 from "./dialog-save-button.vue?vue&type=style&index=0&id=3c900c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c900c3a",
  null
  
)

export default component.exports